import type { Environment } from './environment.type';

export const environment: Environment = {
  production: false,
  appVersion: '1.0.0',
  api: { baseUrl: 'https://zeraora.iiubeo.fr' },
  // Projet PostHog « Blisterr Dev » (region EU) — partage avec la webapp dev.
  // Les events admin sont distingues via la propriete `app: 'admin'` (cf. main.ts).
  posthogKey: 'phc_pfavDU4YMCMxRygCAXVKBtu7Tkz3LuxdCjG9ZhydftkS',
  posthogHost: 'https://eu.i.posthog.com',
};
